enum GroupOrderingNameType {
  Name = 'name',
  Number = 'number',
}

export { GroupOrderingNameType };
